import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const generateRemoteUrl = (status: string[], reloadKey: number, authors: number[], animators: number[]) => {
  const filters: string[] = [];

  if (status.length > 0) {
    filters.push(`status=${status.join(",")}`);
  }

  if (authors.length > 0) {
    filters.push(`meeting_author_ids=${authors.join(",")}`);
  }

  if (animators.length > 0) {
    filters.push(`meeting_animator_ids=${animators.join(",")}`);
  }

  filters.push("fetch_user_infos=true");
  filters.push("fetch_meeting_infos=true");
  filters.push(`reload=${reloadKey}`);

  return `meetings/absence-proofs?${filters.join("&")}`;
};

export const updateAbsenceProofStatus = (
  meetingId: string,
  userId: number,
  status: "validated" | "declined" | "present",
  language: string,
  onSuccess: Function,
  onFail?: Function
) => {
  const payload: { status: string; attendance_status?: boolean } = {
    status: status === "present" ? "validated" : status,
  };

  if (["validated", "present"].includes(status)) {
    payload.attendance_status = status === "present";
  }

  ApiService.put(`meetings/${meetingId}/absence-proofs/${userId}/status`, payload)
    .then(() => {
      onSuccess();
    })
    .catch((err) => {
      console.error("Error updating absence proof status:", err);
      alert(translate(language, "PAGES.MEETINGS_JUSTIFY_ABSENCE.ALERTS.ERROR.UPDATE_STATUS"));
      onFail?.();
    });
};

export const fetchAbsenceProofDetails = (meetingId: string, userId: number, language: string, onSuccess: Function) => {
  ApiService.get(`meetings/${meetingId}/absence-proofs/${userId}`)
    .then((response) => onSuccess(response.data.meeting_absence_proof))
    .catch((error) => {
      console.error("Error fetching absence proof details:", error);
      alert(translate(language, "PAGES.MEETINGS_JUSTIFY_ABSENCE.ALERTS.ERROR.DETAILS_FETCH"));
    });
};

export const fetchAuthorsAndAnimators = (
  setAuthors: Function,
  setAnimators: Function,
  setLoading: Function,
  language: string
) => {
  setLoading(true);
  ApiService.get("meetings/resources")
    .then((response) => {
      setAuthors(response.data.meeting_staff_and_programs.authors);
      setAnimators(response.data.meeting_staff_and_programs.animators);
    })
    .catch((error) => {
      console.error("Error fetching meeting staff:", error);
      alert(translate(language, "ERROR.API_ERROR"));
    })
    .finally(() => setLoading(false));
};
